import { C, TUTORIAL_STEPS } from "../constants";

export function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 28 }}>
      <div style={{
        fontSize: 10, fontFamily: "'DM Mono',monospace", color: C.textFaint,
        letterSpacing: 2, textTransform: "uppercase", marginBottom: 12,
        fontWeight: 700, borderBottom: `1px solid ${C.border}`, paddingBottom: 6,
      }}>
        {title}
      </div>
      {children}
    </div>
  );
}

export function TutorialTooltip({ step, total, onNext }) {
  if (step < 0 || step >= total) return null;
  const t = TUTORIAL_STEPS[step];
  return (
    <div style={{
      position: "fixed", bottom: 110, left: "50%", transform: "translateX(-50%)",
      zIndex: 400, background: C.ink, color: C.bg, padding: "18px 22px",
      borderRadius: 10, maxWidth: 360, width: "calc(100% - 40px)",
      boxShadow: "0 12px 40px rgba(0,0,0,0.5)", border: `2px solid ${C.gold}`,
      fontFamily: "'Source Serif 4',serif",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
        <span style={{ fontSize: 22 }}>{t.icon}</span>
        <div>
          <div style={{ fontSize: 9, fontFamily: "'DM Mono',monospace", color: C.gold, letterSpacing: 2, fontWeight: 700 }}>
            TUTORIAL · {step + 1}/{total}
          </div>
          <div style={{ fontSize: 14, fontFamily: "'Playfair Display',serif", fontWeight: 900, color: C.bg }}>
            {t.title}
          </div>
        </div>
      </div>
      <p style={{ fontSize: 13, lineHeight: 1.7, fontWeight: 700, color: "#C8BFA8", marginBottom: 14 }}>
        {t.text}
      </p>
      <button onClick={onNext} style={{
        padding: "8px 18px", borderRadius: 5, background: C.gold, color: C.ink,
        fontSize: 13, fontWeight: 900, fontFamily: "'DM Mono',monospace",
      }}>
        {step < total - 1 ? "Entendido →" : "¡Comenzar! ⚖"}
      </button>
    </div>
  );
}
